// extracted by mini-css-extract-plugin
export default {"wrapper":"Characteristic_wrapper__yUL+k","valid":"Characteristic_valid__HE3mi","invalid":"Characteristic_invalid__j2Sfl","icon":"Characteristic_icon__eQVi9"};